import { LocalContentProps } from "../types";
import { Status, Wrapper } from "@googlemaps/react-wrapper";
import React, { lazy } from "react";
import { useStateManagerContext } from "~/context/stateManager";

const GoogleMap = lazy(() => import("./GoogleMap"));
const MapGLMap = lazy(() => import("./MapGLMap"));

const Map = () => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();

  const googleMapRender = (status: Status) => {
    switch (status) {
      case Status.LOADING:
        return <></>;
      case Status.FAILURE:
        return <></>;
      case Status.SUCCESS:
        return <GoogleMap />;
      default:
        return <></>;
    }
  };

  if (sdkState.options?.mapProvider === "google") {
    return (
      <Wrapper
        apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ""}
        libraries={["geometry"]}
        render={googleMapRender}
      />
    );
  }

  return <MapGLMap />;
};

export default Map;
